import React, {Component} from 'react'
import {Query, Mutation} from 'react-apollo'

import query from '../../../queries/server/system_settings'
import SystemSettingsTable from "./SystemSettingsTable";
import SystemSettingModal from "./SystemSettingModal";

export default class SystemSettings extends Component {

    state = {
        editOpen: false,
        settingID: null
    }

    toggle = () => {
        console.log(this.state)
        this.setState({editOpen: !this.state.editOpen})
    }

    render() {

        const {editOpen, settingID} = this.state

        return (

            <Query query={query}>
                {({data, error, loading, refetch}) => {

                    return (
                        <div className="d-flex flex-column">
                            <SystemSettingsTable
                                data={data.system_settings}
                                loading={loading}
                                onClick={(settingID) => this.setState({editOpen: true, settingID})}
                            />
                            <SystemSettingModal
                                isOpen={editOpen}
                                toggle={this.toggle}
                                settingID={settingID}
                                onSave={refetch}
                            />
                        </div>
                    )

                }}

            </Query>


        )

    }

}